import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import factoringDataInfo from '../../constants/products/factoring';
import { getCdnUrl } from '../../helpers';
import RegisterButton from '../../components/buttons/RegisterButton';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_SPACE_BETWEEN_ROW_DIRECTION,
  STACK_START_COLUMN_DIRECTION,
} from '../../constants/mui-components';
import {
  factoringBannerContainer,
  bannerStack,
  contentStack,
  titleTypography,
  subtitleTypography,
  imageContainer,
  imageStyles,
} from './styles/factoring-banner.styles';

function FactoringBanner() {
  const { t } = useTranslation();
  const factoringData = factoringDataInfo(t);
  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={factoringBannerContainer}
    >
      <Stack
        className={STACK_SPACE_BETWEEN_ROW_DIRECTION}
        sx={bannerStack}
      >
        <Stack
          className={STACK_START_COLUMN_DIRECTION}
          sx={contentStack}
        >
          <Stack className={STACK_START_COLUMN_DIRECTION} gap="0.5rem">
            <Typography variant="xlarge_2" sx={titleTypography}>
              {factoringData.titleText}
            </Typography>
            <Typography variant="medium_2" sx={subtitleTypography}>
              {factoringData.subtitleText}
            </Typography>
          </Stack>
          <RegisterButton
            text={factoringData.startTextButton}
            typographyVariant="small_3"
          />
        </Stack>
        <Box sx={imageContainer}>
          <CardMedia
            component="img"
            image={getCdnUrl('/images/fingo_icon.webp')}
            alt="factoring_banner"
            style={imageStyles}
          />
        </Box>
      </Stack>
    </Stack>
  );
}

export default FactoringBanner;
